/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2018. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/*
 * Footer Messages
 *
 * This contains all the text for the Footer component.
 */
import { defineMessages } from 'react-intl';
export default defineMessages({
  titleConstruct: {
    id: 'Routes_TitleConstruct',
    defaultMessage: '{title} · {siteTitle}'
  },
  iegTitleConstruct: {
    id: 'Routes_iegTitleConstruct',
    defaultMessage: '{pageTitle} · {scriptTitle} · {siteTitle}'
  },
  siteTitle: {
    id: 'Routes_siteTitle',
    defaultMessage: 'IBM Curam Universal Access'
  },
  benefitSelection: {
    id: 'Routes_benefitSelection',
    defaultMessage: 'Benefit selection'
  },
  paymentBreakdown: {
    id: 'Routes_paymentBreakdown',
    defaultMessage: 'Payment breakdown'
  },
  pageNotFound: {
    id: 'Routes_pageNotFound',
    defaultMessage: 'Page not found'
  },
  applicationForm: {
    id: 'Routes_applicationForm',
    defaultMessage: 'Application form'
  },
  submissionForm: {
    id: 'Routes_submissionForm',
    defaultMessage: 'Submission form'
  },
  submissionFormResolve: {
    id: 'Routes_submissionFormResolve',
    defaultMessage: 'Submission form resolve'
  },
  submissionFormConfirmation: {
    id: 'Routes_submissionFormConfirmation',
    defaultMessage: 'Submission form confirmation'
  },
  appealRequestConfirmation: {
    id: 'Routes_appealRequestConfirmation',
    defaultMessage: 'Appeal request confirmation'
  },
  appealOverviewLabel: {
    id: 'Routes_appealsOverviewLabel',
    defaultMessage: 'Appeal Overview'
  },
  eligibilityHomeLabel: {
    id: 'Routes_eligibilityHomeLabel',
    // eslint-disable-next-line sonarjs/no-duplicate-string
    defaultMessage: 'Check Eligibility'
  },
  eligibilityBenefitSelectionLabel: {
    id: 'Routes_eligibilityBenefitSelectionLabel',
    defaultMessage: 'Benefit Selection'
  },
  eligibilityFormContainerLabel: {
    id: 'Routes_eligibilityFormContainerLabel',
    defaultMessage: 'Check Eligibility'
  },
  eligibilityFilterFormContainerLabel: {
    id: 'Routes_eligibilityFilterFormContainerLabel',
    defaultMessage: 'Check Eligibility'
  },
  eligibilityFormContainerResumeLabel: {
    id: 'Routes_eligibilityFormContainerResumeLabel',
    defaultMessage: 'Check Eligibility'
  },
  eligibilityFormContainerFilterLabel: {
    id: 'Routes_eligibilityFormContainerFilterLabel',
    defaultMessage: 'Check Eligibility'
  },
  eligibilityResultsLabel: {
    id: 'Routes_eligibilityResultsLabel',
    defaultMessage: 'Benefit Eligibility'
  },
  lifeEventsFormContainerLabel: {
    id: 'Routes_lifeEventsFormContainerLabel',
    defaultMessage: 'Life Events'
  },
  lifeEventsFormContainerResumeLabel: {
    id: 'Routes_lifeEventsFormContainerResumeLabel',
    defaultMessage: 'Life Events'
  },
  lifeEventsHistoryLabel: {
    id: 'Routes_lifeEventsHistoryLabel',
    defaultMessage: 'Life Events History'
  },
  lifeEventsOverviewLabel: {
    id: 'Routes_lifeEventsOverviewLabel',
    defaultMessage: 'Life Events Overview'
  },
  lifeEventsRemoteSystemsLabel: {
    id: 'Routes_lifeEventsRemoteSystemsLabel',
    defaultMessage: 'Consent Page for Citizen'
  },
  lifeEventsConfirmation: {
    id: 'Routes_lifeEventsConfirmation',
    defaultMessage: 'Change submitted'
  },
  appealForm: {
    id: 'Routes_appealForm',
    defaultMessage: 'Appeal form'
  },
  appealDetails: {
    id: 'Routes_appealDetails',
    defaultMessage: 'Appeal Details'
  },
  noticeDetails: {
    id: 'Routes_noticeDetails',
    defaultMessage: 'Notice Details'
  },
  verificationDetails: {
    id: 'Routes_verificationDetails',
    defaultMessage: 'Verification Details'
  },
  iegVerificationDetails: {
    id: 'Routes_IEGVerificationDetails',
    defaultMessage: 'Verification Details'
  }
});